export const DEEPCOPY_IGNORE_SYMBOLS = new Set([
    'instantiateHierarchy',
    'getClassName',
    'getLODLevels',
    'addLODLevel',
    'getLODLevelAtDistance',
    'removeLODLevel',
    'getLOD',
    'getTotalVertices',
    'getVerticesData',
    'getVertexBuffer',
    'isVerticesDataPresent',
    'isVertexBufferUpdatable',
    'getVerticesDataKinds',
    'getTotalIndices',
    'getIndices',
    'isReady',
    'freezeNormals',
    'unfreezeNormals',
    'refreshBoundingInfo',
    'subdivide',
    'setVerticesData',
    'removeVerticesData',
    'markVerticesDataAsUpdatable',
    'setVerticesBuffer',
    'updateVerticesData',
    'updateMeshPositions',
    'makeGeometryUnique',
    'setIndices',
    'updateIndices',
    'toLeftHanded',
    'registerBeforeRender',
    'unregisterBeforeRender',
    'registerAfterRender',
    'unregisterAfterRender',
    'render',
    'cleanMatrixWeights',
    'normalizeSkinFourWeights',
    'normalizeSkinWeightsAndExtra',
    'validateSkinning',
    'isInFrustum',
    'setMaterialByID',
    'setMaterialById',
    'getAnimatables',
    'bakeTransformIntoVertices',
    'bakeCurrentTransformIntoVertices',
    'clone',
    'dispose',
    'applyDisplacementMap',
    'applyDisplacementMapFromBuffer',
    'convertToFlatShadedMesh',
    'convertToUnIndexedMesh',
    'flipFaces',
    'increaseVertices',
    'forceSharedVertices',
    'createInstance',
    'synchronizeInstances',
    'optimizeIndices',
    'serialize',
    'setPositionsForCPUSkinning',
    'setNormalsForCPUSkinning',
    'applySkeleton',
    'addInstance',
    'removeInstance',
    'registerInstancedBuffer',
    'simplify',
    'thinInstanceAdd',
    'thinInstanceAddSelf',
    'thinInstanceRegisterAttribute',
    'thinInstanceSetMatrixAt',
    'thinInstanceSetAttributeAt',
    'thinInstanceSetBuffer',
    'thinInstanceBufferUpdated',
    'thinInstancePartialBufferUpdate',
    'thinInstanceGetWorldMatrices',
    'thinInstanceRefreshBoundingInfo',
    'getEmittedParticleSystems',
    'getHierarchyEmittedParticleSystems',
    'transferToEffect',
    'getMeshUniformBuffer',
    'getBoundingInfo',
    'setBoundingInfo',
    'buildBoundingInfo',
    'normalizeToUnitCube',
    'getWorldMatrix',
    'movePOV',
    'calcMovePOV',
    'rotatePOV',
    'calcRotatePOV',
    'isCompletelyInFrustum',
    'intersectsMesh',
    'intersectsPoint',
    'moveWithCollisions',
    'intersects',
    'releaseSubMeshes',
    'addChild',
    'removeChild',
    'updateFacetData',
    'getFacetLocalNormals',
    'getFacetLocalPositions',
    'getFacetLocalPartitioning',
    'getFacetPosition',
    'getFacetPositionToRef',
    'getFacetNormal',
    'getFacetNormalToRef',
    'getFacetsAtLocalCoordinates',
    'getClosestFacetAtCoordinates',
    'getClosestFacetAtLocalCoordinates',
    'getFacetDataParameters',
    'disableFacetData',
    'createNormals',
    'alignWithNormal',
    'disableEdgesRendering',
    'enableEdgesRendering',
    'getConnectedParticleSystems',
    'createOrUpdateSubmeshesOctree',
    'getPhysicsImpostor',
    'applyImpulse',
    'setPhysicsLinkWith',
    'isUsingPivotMatrix',
    'updatePoseMatrix',
    'getPoseMatrix',
    'markAsDirty',
    'setPreTransformMatrix',
    'setPivotMatrix',
    'getPivotMatrix',
    'freezeWorldMatrix',
    'unfreezeWorldMatrix',
    'getAbsolutePosition',
    'setAbsolutePosition',
    'setPositionWithLocalVector',
    'getPositionExpressedInLocalSpace',
    'locallyTranslate',
    'lookAt',
    'getDirection',
    'getDirectionToRef',
    'setDirection',
    'setPivotPoint',
    'getPivotPoint',
    'getPivotPointToRef',
    'getAbsolutePivotPoint',
    'getAbsolutePivotPointToRef',
    'setParent',
    'attachToBone',
    'detachFromBone',
    'rotate',
    'rotateAround',
    'translate',
    'addRotation',
    'computeWorldMatrix',
    'resetLocalMatrix',
    'registerAfterWorldMatrixUpdate',
    'unregisterAfterWorldMatrixUpdate',
    'getPositionInCameraSpace',
    'getDistanceToCamera',
    'getChildTransformNodes',
    'isDisposed',
    'getScene',
    'getEngine',
    'addBehavior',
    'removeBehavior',
    'getBehaviorByName',
    'updateCache',
    'isSynchronizedWithParent',
    'isSynchronized',
    'isEnabled',
    'setEnabled',
    'isDescendantOf',
    'getDescendants',
    'getChildMeshes',
    'getChildren',
    'getAnimationByName',
    'createAnimationRange',
    'deleteAnimationRange',
    'getAnimationRange',
    'getAnimationRanges',
    'beginAnimation',
    'serializeAnimationRanges',
    'getHierarchyBoundingVectors',
    ]);